export var CalendarStateToken;
(function (CalendarStateToken) {
    CalendarStateToken["DEFAULT"] = "DEFAULT";
    CalendarStateToken["DISABLED"] = "DISABLED";
    CalendarStateToken["LOADING"] = "LOADING";
    CalendarStateToken["SUCCESS"] = "SUCCESS";
    CalendarStateToken["ERROR"] = "ERROR";
    CalendarStateToken["FOCUS"] = "FOCUS";
})(CalendarStateToken || (CalendarStateToken = {}));
